const handleContactSubmission = function (formEl) {
  var httpRequest = new XMLHttpRequest();
  if (!httpRequest) {
    console.error("Giving up :( Cannot create an XMLHTTP instance");
    return false;
  }
  httpRequest.onreadystatechange = function () {
    if (httpRequest.readyState === XMLHttpRequest.DONE) {
      if (httpRequest.status === 200) {
        closeActiveModal();
        formEl.reset();
      } else {
      }
    }
  };

  let name = formEl.querySelector("input[name=name]").value;
  let company = formEl.querySelector("input[name=company]").value;
  let phone = formEl.querySelector("input[name=phone]").value;
  let email = formEl.querySelector("input[name=email]").value;
  let nature = formEl.querySelector("select[name=nature]").value;
  let text = formEl.querySelector("textarea[name=text]").value;

  httpRequest.open("POST", "/wp-admin/admin-ajax.php");
  httpRequest.setRequestHeader(
    "Content-Type",
    "application/x-www-form-urlencoded"
  );

  httpRequest.send(
    `action=contact_inquiry&name=${encodeURIComponent(
      name
    )}&company=${encodeURIComponent(company)}&phone=${encodeURIComponent(
      phone
    )}&email=${encodeURIComponent(email)}&nature=${encodeURIComponent(
      nature
    )}&text=${encodeURIComponent(text)}`
  );
};

const initContactForm = function () {
  let contactSubmit = document.querySelector("#submit-contact");
  if (contactSubmit) {
    contactSubmit.addEventListener("click", function (e) {
      e.preventDefault();
      let honey = document.querySelector("input[name=surname]").value;
      let formEl = document.querySelector(".contact-form");
      if (formEl.reportValidity() === true && honey === "") {
        handleContactSubmission(formEl);
      }
    });
  }
};

export { initContactForm };
